import { ItemInstance } from '@headless-tree/core';
import { FileItemType } from '../../types';

export const isItemFolder = <T extends FileItemType>(
  item: ItemInstance<T>
): boolean => item.getItemData().children !== null;
